import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative bg-[#071426] grid place-items-center px-4 overflow-hidden grain" data-testid="admin-login-page">
      <img src="/img/dubai-hero.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-[#071426]/70" />
      <form onSubmit={submit} className="relative w-full max-w-sm rounded-[28px] bg-white/[0.92] backdrop-blur-2xl border border-white/40 p-8 shadow-2xl" data-testid="admin-login-form">
        <div className="h-11 w-11 rounded-2xl bg-[#0B1F3A] grid place-items-center"><Lock size={18} className="text-[#C7A76C]" /></div>
        <h1 className="font-display mt-6 text-2xl font-bold text-[#0B1F3A]">FAD Admin</h1>
        <p className="mt-1 text-sm text-[#697386]">Sign in with your administrator account.</p>
        <label htmlFor="admin-email" className="block mt-7 text-sm font-medium mb-2">Email</label>
        <input id="admin-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className="field" data-testid="admin-login-email-input" />
        <label htmlFor="admin-password" className="block mt-4 text-sm font-medium mb-2">Password</label>
        <input id="admin-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="field" data-testid="admin-login-password-input" />
        {error && <p className="mt-4 text-sm text-[#C2410C]" role="alert" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-primary w-full mt-6" data-testid="admin-login-submit-button">
          {loading ? <Loader2 size={16} className="animate-spin" /> : "Sign in"}
        </button>
        <Link to="/" className="mt-6 flex items-center justify-center gap-2 text-sm text-[#697386] hover:text-[#0B1F3A]" data-testid="admin-login-back-link">
          <ArrowLeft size={14} /> Back to website
        </Link>
      </form>
    </div>
  );
}
